var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("text",{"id":"Agnieszka_Kaźmierczyk","data-name":"Agnieszka Kaźmierczyk","transform":"translate(0 16)","fill":"#fff","fontSize":"20","fontFamily":"Helvetica-Bold, Helvetica","fontWeight":"700"},React.createElement("tspan",{"x":"0","y":"0"},"Agnieszka Kaźmierczyk")));
}

Logo.defaultProps = {"width":"226","height":"21","viewBox":"0 0 226 21"};

module.exports = Logo;

Logo.default = Logo;
